/**
 * PDFTron/Apryse encodes non-ASCII characters in names (e.g. color separations)
 * using a "+xHH" hex format.  For example "Tracés" arrives as "Trac+xE9s".
 * This helper converts those sequences back to the real Unicode characters.
 */
export const decodePdfTronName = (name: string): string =>
  name.replace(/\+x([0-9A-Fa-f]{2})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
